import { styled } from "simplydo/react/styled";

export const FieldTitleClamp = styled.div`
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FieldEntry = styled(FieldTitleClamp)`
  font-size: 14px;
  line-height: 16px;
  padding-right: 8px;
`;

export const PercentIcon = styled.div`
  margin-left: -1px;
  margin-right: 8px;
  padding: 6px 3px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.violet.solid};
  display: flex;
  align-items: center;
`;
